module.exports = __webpack_public_path__ + "static/media/network.fd95954b.svg";